import { computed, Ref } from '@vue/composition-api';
import { HomeBanner, JumpType } from '@/types/home';

/**
 * 格式化给@tencent/wphk-components-banner使用的banner list数据
 */
export function useBannerList(positionBannerList: Ref<HomeBanner[]>, position: string) {
  const bannerList = computed(() => positionBannerList.value.map((item) => {
    const { img, jumpUrl, id, reportInfo, appid, path, username, jumpType, bannerAlt }  = item;
    return {
      bannerTag: {
        ext1: position,
        ext2: id,
        ext3: reportInfo.fbanner_no,
      },
      weight: 0,
      bannerJumpInfo: jumpType === JumpType.H5 ? { jumpUrl } : {
        miniAppId: appid, miniAppPath: path, miniAppUsername: username,
      },
      bannerAlt,
      bannerImgUrl: img,
    };
  }));
  return {
    bannerList,
  };
}
